// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import BackIcon from '../../../assets/svg/backArrow.svg';
import ContentWrapper from '../../../generic-components/ContentWrapper';
import ThreeColumnsContainer from '../../../generic-components/Layout/ThreeColumnsContainer';
import TaxBucketPersonalization from '../components/TaxBucketPersonalization';
import { TAX_BUCKET_PERSONALIZATION, TAX_BUCKET_PERSONALIZATION_PAGE_HEADER } from '../constants';
import { useStore } from '../../../store';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import { VIEWS_MAP } from '../../../router/constants';
import Button from '../../../generic-components/Button';
import Icon from '../../../generic-components/Icon';
import PageLayout from '../../../generic-components/PageLayout/PageLayout';

const TaxBucketModifyFlow = () => {
  const navigate = useNavigate();
  const summary = useStore((state) => state.summary);
  const navPath = summary.taxBucketBalance.active ? '/tax-bucket-dashboard/:main' : '/dashboard';

  const { STEP_1, STEP_2_OTHER } = TAX_BUCKET_PERSONALIZATION.STEPS;
  const [currentStep, setCurrentStep] = useState(STEP_2_OTHER);
  const { t } = useTranslation();

  useEffect(() => {
    if (!validateFeatureFlag(FEATURE_FLAG.TAX_BUCKET)) navigate(`/${VIEWS_MAP.DASHBOARD}`);
  }, []);

  // wrapperClassName='pt-[78px] pl-[72px] pr-[32px] ml-[100px] pc-md:ml-[256px]'
  return (
    <PageLayout>
      <div className='flex items-center gap-[24px] mb-[24px]'>
        <Button
          onClick={() => {
            if (currentStep === STEP_1) {
              navigate(navPath);
            } else {
              setCurrentStep(currentStep - 1);
            }
          }}
          className=''
          id=''
          childElement={<Icon className='w-[10px]' src={BackIcon} />}
        />
        <Heading.H5 fontWeight={FontWeight.MEDIUM}>{t(TAX_BUCKET_PERSONALIZATION_PAGE_HEADER)}</Heading.H5>
      </div>
      <ContentWrapper>
        <ThreeColumnsContainer
          firstColumnClassname='w-full'
          firstColumnChildren={[<TaxBucketPersonalization currentStep={currentStep} setCurrentStep={setCurrentStep} />]}
        />
      </ContentWrapper>
    </PageLayout>
  );
};

export default TaxBucketModifyFlow;
